import { CIcon } from '~/icons/types'

export const ciBuses: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M24 16.453a36.037 36.037 0 0 0-.5-5.67l-.744-4.4a.498.498 0 0 0-.057-.159C22.168 5.26 19.465 5 19.119 5H1.508A1.515 1.515 0 0 0 0 6.52l.015 9.5a1.418 1.418 0 0 0 .419 1.007c.268.267.63.417 1.009.418h1.709c.118.32.302.61.541.853.358.35.814.58 1.307.663.136.024.274.038.412.039a2.464 2.464 0 0 0 2.121-1.223 2.42 2.42 0 0 0 .13-.327h8.37a2.451 2.451 0 0 0 4.559 0h2.913a.5.5 0 0 0 .5-.5L24 16.453Zm-1.24-3.58-1.988-.638c-1.322-.36-2.68-.57-4.05-.626V8.125h5.314l.477 2.825c.108.636.175 1.28.247 1.923Zm-15.288-1.3V8.125h3.869v3.45l-3.869-.002Zm-4.381 0V8.125h3.381v3.45l-3.381-.002Zm9.25-3.45h3.381v3.451h-3.381V8.123ZM6.669 17.27a1.461 1.461 0 0 1-2.107.453 1.457 1.457 0 0 1 .05-2.406c.237-.155.514-.238.797-.239h.077a1.458 1.458 0 0 1 1.186 2.19l-.003.002Zm11.644.73a1.458 1.458 0 1 1-.002-2.917A1.458 1.458 0 0 1 18.313 18Zm2.448-1.55a2.45 2.45 0 1 0-4.9 0H7.852c0-.034.01-.067.008-.1a2.458 2.458 0 0 0-4.7-.79 2.43 2.43 0 0 0-.2.893H1.438a.429.429 0 0 1-.426-.425L1 6.519a.524.524 0 0 1 .226-.43A.515.515 0 0 1 1.508 6h17.611a6.8 6.8 0 0 1 2.671.662l.077.459H2.591a.5.5 0 0 0-.5.5v4.45a.5.5 0 0 0 .5.5h13.1c1.612.001 3.218.207 4.779.612l2.412.774c.067.828.115 1.657.122 2.484l-2.243.009Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'buses',
  type: 'thin'
}
